import { render } from "./Menu.vue?vue&type=template&id=0d8697cd&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0d8697cd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d8697cd"

export default script